import { SxProps } from '@mui/material'

const styles = {
  // One chip per item stage, stacked so a mixed order does not widen the Status column
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 0.5
  } as SxProps,

  // Item stage names run long ("Awaiting Shopper Pickup from Locker ×1"). A chip keeps its label on
  // one line, which made the label the column's minimum width and pushed it past the table's edge,
  // so the label wraps inside the chip instead.
  chip: {
    height: 'auto',
    maxWidth: '100%',
    paddingY: 0.5,
    '& .MuiChip-label': {
      display: 'block',
      whiteSpace: 'normal'
    }
  } as SxProps
}

export default styles
